import { GenIcon } from '../helpers/IconBase.es.js';

const CopyrightColored = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 16 16", fill: "none" },
    child: [
      {
        tag: "g",
        attr: { clipPath: "url(#clip0_16327_233)" },
        child: [
          {
            tag: "path",
            attr: {
              d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0.00478125 12.4163 3.58369 15.9952 8 16ZM4.7 4.7C6.52384 2.88062 9.47616 2.88062 11.3 4.7C11.5558 4.96484 11.5484 5.38688 11.2836 5.64266C11.0253 5.89219 10.6157 5.89219 10.3573 5.64266C9.05544 4.34109 6.94487 4.34134 5.64331 5.64328C4.34175 6.94522 4.342 9.05575 5.64394 10.3573C6.94563 11.6587 9.05569 11.6587 10.3574 10.3573C10.6222 10.1015 11.0443 10.1089 11.3 10.3737C11.5495 10.6321 11.5495 11.0416 11.3 11.3C9.4775 13.1225 6.52256 13.1225 4.70003 11.3C2.87747 9.47747 2.87747 6.52253 4.7 4.7Z",
              fill: "#0200BC"
            }
          }
        ]
      },
      {
        tag: "defs",
        attr: {},
        child: [
          {
            tag: "clipPath",
            attr: { id: "clip0_16327_233" },
            child: [
              {
                tag: "rect",
                attr: { width: "16", height: "16", fill: "white" }
              }
            ]
          }
        ]
      }
    ]
  })(props);
};

export { CopyrightColored };
